{
  "v11.lecteur.annulation.confirmer": "Confirm the cancellation",
  "v11.lecteur.annulation.echec": "The cancellation did not succeed.",
  "v11.lecteur.annulation.faite": "Request cancelled.",
  "v11.lecteur.annulation.propriete": "The server checks that the request is yours.",
  "v11.lecteur.annulation.sans_droits": "Cancelling withdraws the request without changing your rights.",
  "v11.lecteur.annuler": "Cancel",
  "v11.lecteur.annuler_sollicitation.titre": "Cancel a personal request",
  "v11.lecteur.cible.apercu": "Preview {{application}} · revision {{revision}} · {{etat}}",
  "v11.lecteur.cible.aucune_choisie": "No target chosen.",
  "v11.lecteur.cible.deploiement": "Deployment in {{environnement}} · commit {{revision}} · {{etat}}",
  "v11.lecteur.cible.libelle": "Application target",
  "v11.lecteur.cible_application.titre": "Application of the selected version",
  "v11.lecteur.cibles.choisir": "Choose one of the {{n}} available targets.",
  "v11.lecteur.cibles.quoi": "the available targets",
  "v11.lecteur.cibles.titre": "Available targets",
  "v11.lecteur.cibles.vide": "No target for this version: no preview at its revision, no deployment.",
  "v11.lecteur.circuit.aucun": "No recipient is designated: the organisation administration will decide.",
  "v11.lecteur.circuit.chargement": "Looking up the authorised people…",
  "v11.lecteur.circuit.non_divulguable": "The authorised people cannot be named to you.",
  "v11.lecteur.circuit.profils": "Decided by: {{profils}}.",
  "v11.lecteur.code.ACCESS_REQUEST_ALREADY_MEMBER": "You are already a member of this project.",
  "v11.lecteur.code.ACCESS_REQUEST_ALREADY_PENDING": "A request is already pending for this project.",
  "v11.lecteur.code.ACCESS_REQUEST_NOT_FOUND": "This request cannot be found or is not yours.",
  "v11.lecteur.code.ACCESS_REQUEST_NOT_PENDING": "This request has already been answered: it can no longer be cancelled.",
  "v11.lecteur.code.DROIT_NON_TENU": "You do not hold the right required to read these targets.",
  "v11.lecteur.code.RESOURCE_UNAVAILABLE": "This version cannot be found in this project.",
  "v11.lecteur.code.SANS_SESSION": "Your session has expired: sign in again.",
  "v11.lecteur.code.VALIDATION_ERROR": "The input is not valid.",
  "v11.lecteur.effets.admission": "The request covers admission only, with the Reader profile.",
  "v11.lecteur.effets.aucun_droit": "Sending grants no right: an authorised person decides.",
  "v11.lecteur.effets.suivi": "You follow it in your requests and can cancel it while it is pending.",
  "v11.lecteur.envoi_echec": "The request could not be sent.",
  "v11.lecteur.envoyee": "Request sent.",
  "v11.lecteur.envoyer": "Send the request",
  "v11.lecteur.espaces_illisibles": "Your project list could not be read.",
  "v11.lecteur.etat.chargement": "Loading {{quoi}}…",
  "v11.lecteur.etat.en_cours": "In progress…",
  "v11.lecteur.etat.erreur": "Reading {{quoi}} failed.",
  "v11.lecteur.etat.reessayer": "Retry",
  "v11.lecteur.etat.refus": "You are not allowed to read {{quoi}}.",
  "v11.lecteur.etat_apercu.disponible": "available",
  "v11.lecteur.etat_apercu.expiree": "expired",
  "v11.lecteur.etat_apercu.indisponible": "unavailable",
  "v11.lecteur.etat_deploiement.disponible": "available",
  "v11.lecteur.etat_deploiement.indisponible": "unavailable",
  "v11.lecteur.etat_deploiement.revision_incompatible": "incompatible revision",
  "v11.lecteur.fermer": "Close",
  "v11.lecteur.liens.apercu_expire": "This preview has expired: restart it from the version page.",
  "v11.lecteur.liens.apercu_indisponible": "This preview is not running.",
  "v11.lecteur.liens.aucun_apercu": "No preview chosen.",
  "v11.lecteur.liens.aucun_deploiement": "No deployment chosen.",
  "v11.lecteur.liens.choisir_d_abord": "Choose a target first.",
  "v11.lecteur.liens.comprendre_acces": "Understand my access",
  "v11.lecteur.liens.deploiement_indisponible": "This deployment did not succeed.",
  "v11.lecteur.liens.ouvrir_apercu": "Open the preview",
  "v11.lecteur.liens.ouvrir_service": "Open the service",
  "v11.lecteur.liens.retour_version": "Back to the version",
  "v11.lecteur.liens.retour_vue": "Back to the project",
  "v11.lecteur.liens.revision_incompatible": "The environment has since been serving another version.",
  "v11.lecteur.motif.aide": "Say why you need this project; the reason is sent to the people who decide.",
  "v11.lecteur.motif.libelle": "Reason for the request",
  "v11.lecteur.motif.obligatoire": "The reason is required.",
  "v11.lecteur.motif.trop_long": "The reason exceeds {{max}} characters.",
  "v11.lecteur.portee.admission": "Admission to project {{projet}}, with the Reader profile by default.",
  "v11.lecteur.sans_organisation": "No organisation is attached to your session.",
  "v11.lecteur.sans_projet": "No project is specified.",
  "v11.lecteur.selection.application": "Application",
  "v11.lecteur.selection.chargement": "Loading the chosen target…",
  "v11.lecteur.selection.commit": "Commit",
  "v11.lecteur.selection.correspondance_revision": "Exact match: revision {{revision}} of version {{numero}}.",
  "v11.lecteur.selection.correspondance_terme": "Match",
  "v11.lecteur.selection.correspondance_version": "Exact match: deployment of version {{numero}}.",
  "v11.lecteur.selection.depend_de_la_liste": "The chosen target depends on the target list.",
  "v11.lecteur.selection.environnement": "Environment: {{nom}}",
  "v11.lecteur.selection.environnement_terme": "Environment",
  "v11.lecteur.selection.revision": "Revision",
  "v11.lecteur.selection.titre": "Chosen target",
  "v11.lecteur.selection.version": "Version",
  "v11.lecteur.sollicitation.deja_annulee": "This request is already cancelled.",
  "v11.lecteur.sollicitation.depuis": "Sent on",
  "v11.lecteur.sollicitation.introuvable": "You have no request with this number on this project.",
  "v11.lecteur.sollicitation.motif": "Reason",
  "v11.lecteur.sollicitation.projet": "Project",
  "v11.lecteur.sollicitation.quoi": "the request",
  "v11.lecteur.sollicitation.sans_motif": "No reason",
  "v11.lecteur.sollicitation.statut": "Status",
  "v11.lecteur.solliciter.titre": "Request access to the project",
  "v11.lecteur.statut.approved": "Accepted",
  "v11.lecteur.statut.cancelled": "Cancelled",
  "v11.lecteur.statut.pending": "Pending",
  "v11.lecteur.statut.rejected": "Rejected",
  "v11.lecteur.suivi.quoi": "your requests",
  "v11.lecteur.version.designation_absente": "No version has been designated by the release manager: the most recent one is shown.",
  "v11.lecteur.version.identifiee": "Version {{numero}} (commit {{commit}})",
  "v11.lecteur.version.la_plus_recente": "Most recent",
  "v11.lecteur.version.libelle": "Version to test",
  "v11.lecteur.version.liste_illisible": "The version list could not be read: only the most recent one is offered.",
  "v11.lecteur.version.titre": "Version and targets"
}
